/**
 * Sentinel for the "every classroom" scope in URL state.
 *
 * Lives in `constants/` rather than inside `features/materials/` because
 * other features link INTO a cross-classroom view — the home page's "Ver
 * todos los materiales" is the first — and a cross-feature import is banned
 * by `.claude/rules/architecture.md`. `features/materials/materialsState.ts`
 * re-exports it so its own call sites keep their feature-local path.
 *
 * It is deliberately a truthy string, not `null` or `""`: pages that scope to
 * one classroom by default resolve their default only when the param is
 * ABSENT, so "all" has to be distinguishable from "not chosen yet".
 */
export const ALL_CLASSROOMS = "all"
